import moment from 'moment';

const daysToMonths = days =>
  Math.floor(moment.duration(days, 'days').asMonths());

export default daysToMonths;
